const style = {
  paddingTop: '25px',
};


export default {
  style,
};



// WEBPACK FOOTER //
// ./src/scenes/Users/components/Search/style.js